export default function Logo({ size = "md" }) {
  const big = size === "lg";
  return (
    <div className="flex items-center gap-3 min-w-0" data-testid="brand-logo">
      <img
        src="/carrierlaunch-logo.png"
        alt="CarrierLaunch semi truck on the highway"
        className={`${big ? "w-16 h-16 sm:w-20 sm:h-20" : "w-10 h-10 sm:w-14 sm:h-14"} object-cover border border-[#FFD600]/40 shrink-0`}
      />
      <div className="leading-none">
        <div className={`cl-wordmark ${big ? "text-[clamp(1.1rem,5.2vw,1.875rem)] sm:text-4xl" : "text-[clamp(0.75rem,3.9vw,1.25rem)] sm:text-2xl"}`}>
          CARRIER<span className="text-[#FFD600]">LAUNCH</span>
        </div>
        <div className="cl-road mt-1.5" aria-hidden="true" />
      </div>
    </div>
  );
}
